export async function store({}, payload) {
  const data = await this.$frontendRepositories.submitPersion.store(payload);
  return data;
}
export async function getByUserAndCompany({}, payload) {
  const data = await this.$frontendRepositories.submitPersion.getByUserAndCompany(payload);
  return data;
}
